import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/drivers")({
  component: Outlet,
  head: () => ({
    meta: [{ title: "Drivers · Lecmo Admin" }, { name: "robots", content: "noindex" }],
  }),
});
